/* ET - Collection Nav: keeps the active pill in view and shows the arrows (mouse users) while the pills overflow. */
(function () {
  'use strict';

  // Guard against double execution when the section is on the page more than once.
  var READY_ATTRIBUTE = 'data-et-collection-nav-ready';
  if (document.documentElement.hasAttribute(READY_ATTRIBUTE)) return;
  document.documentElement.setAttribute(READY_ATTRIBUTE, '');

  var ROOT_SELECTOR = '[data-et-collection-nav-root]';
  var SCROLLER_SELECTOR = '[data-et-collection-nav]';
  var ACTIVE_SELECTOR = '.et-collection-nav__pill--active';
  var PREV_SELECTOR = '[data-et-collection-nav-prev]';
  var NEXT_SELECTOR = '[data-et-collection-nav-next]';
  var CLASS_SCROLL_START = 'et-collection-nav__nav--scroll-start';
  var CLASS_SCROLL_END = 'et-collection-nav__nav--scroll-end';

  var instances = [];

  function getGutter(scroller) {
    var list = scroller.firstElementChild;
    return list ? parseFloat(window.getComputedStyle(list).paddingLeft) || 0 : 0;
  }

  function scrollScroller(scroller, left, smooth) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: left, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    } else {
      scroller.scrollLeft = left;
    }
  }

  // Aligns the element with the list's start gutter. Only the scroller's scrollLeft changes, so the page never
  // scrolls vertically. Elements that are already fully visible are left alone.
  function revealInScroller(scroller, element) {
    if (!scroller || !element) return;

    var scrollerRect = scroller.getBoundingClientRect();
    var elementRect = element.getBoundingClientRect();
    if (scrollerRect.width === 0) return;
    if (elementRect.left >= scrollerRect.left && elementRect.right <= scrollerRect.right) return;

    var left = Math.max(0, Math.round(scroller.scrollLeft + (elementRect.left - scrollerRect.left) - getGutter(scroller)));
    scrollScroller(scroller, left, false);
  }

  function updateState(instance) {
    var scroller = instance.scroller;
    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var overflowing = maxScroll > 1;

    instance.root.classList.toggle(CLASS_SCROLL_START, overflowing && scroller.scrollLeft > 1);
    instance.root.classList.toggle(CLASS_SCROLL_END, overflowing && scroller.scrollLeft < maxScroll - 1);
  }

  function scheduleUpdate(instance) {
    if (instance.frame) return;
    instance.frame = window.requestAnimationFrame(function () {
      instance.frame = null;
      updateState(instance);
    });
  }

  // Pages by the visible width minus the gutters, so the pill cut off at the edge becomes the first one in view.
  function page(instance, direction) {
    var scroller = instance.scroller;
    var distance = Math.max(scroller.clientWidth - getGutter(scroller) * 2 - 48, 120);
    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var left = Math.min(maxScroll, Math.max(0, scroller.scrollLeft + distance * direction));
    scrollScroller(scroller, left, true);
  }

  function setup(root) {
    var scroller = root.querySelector(SCROLLER_SELECTOR);
    if (!scroller) return;

    var instance = { root: root, scroller: scroller, frame: null, observer: null };

    instance.onScroll = function () {
      scheduleUpdate(instance);
    };
    instance.onClick = function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest(PREV_SELECTOR)) page(instance, -1);
      if (target.closest(NEXT_SELECTOR)) page(instance, 1);
    };

    scroller.addEventListener('scroll', instance.onScroll, { passive: true });
    root.addEventListener('click', instance.onClick);

    if ('ResizeObserver' in window) {
      instance.observer = new ResizeObserver(instance.onScroll);
      instance.observer.observe(scroller);
      if (scroller.firstElementChild) instance.observer.observe(scroller.firstElementChild);
    } else {
      window.addEventListener('resize', instance.onScroll);
    }

    revealInScroller(scroller, scroller.querySelector(ACTIVE_SELECTOR));
    updateState(instance);
    instances.push(instance);
  }

  function teardown(instance) {
    instance.scroller.removeEventListener('scroll', instance.onScroll);
    instance.root.removeEventListener('click', instance.onClick);
    if (instance.observer) {
      instance.observer.disconnect();
    } else {
      window.removeEventListener('resize', instance.onScroll);
    }
    if (instance.frame) window.cancelAnimationFrame(instance.frame);
  }

  function init(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function (root) {
      var alreadySetUp = instances.some(function (instance) {
        return instance.root === root;
      });
      if (!alreadySetUp) setup(root);
    });
  }

  function destroy(container) {
    if (!container) return;

    instances = instances.filter(function (instance) {
      if (container.contains(instance.root)) {
        teardown(instance);
        return false;
      }
      return true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || typeof block.closest !== 'function') return;

    var scroller = block.closest(SCROLLER_SELECTOR);
    if (scroller) revealInScroller(scroller, block);
  });
})();
